import IUserData from 'types/sign-in/IUserData'
import { IResponsesValue, IValidationUserResponses, IWordBank, WordBankCategory } from 'types'
import { IInitiative } from '../Interfaces'

export const publicProfileInitialState = {
  user: null as IUserData,
  responses: null as IResponsesValue,
  error: '' as string,
  validation: null as IValidationUserResponses,
  disabled: true as boolean,
  publicMode: true as boolean,
  wordBanks: {} as {
    [WordBankCategory.Xfactor]: IWordBank[]
    [WordBankCategory.TalentTags]: IWordBank[]
    [WordBankCategory.CompanyDescriptor]: IWordBank[]
  },
  initiatives: [] as IInitiative[]
}

export type PublicProfileState = typeof publicProfileInitialState
